import { useSelector } from "react-redux";
import { useCustomFieldListApi } from "../../sharedmailbox/customFields/api";
import { CUSTOM_FIELDS_TYPES } from "../constants";
import {
  CUSTOM_FIELD_FILTER_KEY,
  FILTER_ICON_MAP,
  FILTER_KEYS,
  FILTER_LABEL_MAP,
  STATUS_LABEL_MAP,
} from "../constants/conversationFilter";
import {
  currentSharedMailBoxIdSelector,
  currentSharedmailBoxTagsSelector,
  currentSharedmailBoxUsersSelector,
} from "../selectors";

const getMenuListFromLabelMap = (labelObj) => {
  return Object.entries(labelObj).map(([k, v]) => ({ name: v, value: k }));
};

const getMenuListFromSmUserData = (users = []) => {
  const usersArr = [{ name: "Unassigned", userid: -1 }, ...users];
  return usersArr.map(({ name, userid }) => ({ name: name, value: userid }));
};

const getMenuListFromTagsData = (tags = []) => {
  return tags.map(({ id, name }) => ({ name: name, value: id }));
};

const getFilterDataObject = ({
  menuList = [],
  filterKey = "",
  customFieldData = {},
}) => {
  let label = "";
  let icon = FILTER_ICON_MAP[filterKey] ?? null;
  let menuListData = menuList;
  if (filterKey === CUSTOM_FIELD_FILTER_KEY) {
    label = customFieldData?.display_name;
    menuListData = customFieldData?.dropdown_values?.map(
      ({ id, display_name }) => ({ name: display_name, value: id })
    );
  } else {
    label = FILTER_LABEL_MAP[filterKey];
  }
  return {
    menuList: menuListData ?? [],
    label,
    icon,
    filterKey,
    customFieldData,
  };
};

const getCustomFieldsData = (customFieldResponse) => {
  const customFieldsList = customFieldResponse?.data?.data;
  if (!Array.isArray(customFieldsList) || customFieldsList.length === 0) {
    return [];
  }
  return customFieldsList[0]?.custom_fields;
};

export const useConversationFiltersData = () => {
  const smId = useSelector(currentSharedMailBoxIdSelector);
  const smUsers = useSelector(currentSharedmailBoxUsersSelector);
  const smTags = useSelector(currentSharedmailBoxTagsSelector);
  const { data: customFieldResponse } = useCustomFieldListApi(smId);

  let filtersData = [];
  Object.values(FILTER_KEYS).forEach((filterKey) => {
    switch (filterKey) {
      case FILTER_KEYS.STATUS_FILTER:
        filtersData.push(
          getFilterDataObject({
            menuList: getMenuListFromLabelMap(STATUS_LABEL_MAP),
            filterKey,
          })
        );
        break;
      case FILTER_KEYS.ASSIGNEE_FILTER:
        filtersData.push(
          getFilterDataObject({
            menuList: getMenuListFromSmUserData(smUsers),
            filterKey,
          })
        );
        break;
      case FILTER_KEYS.TAGS_FILTER:
      case FILTER_KEYS.WITHOUT_TAGS_FILTER:
        filtersData.push(
          getFilterDataObject({
            menuList: getMenuListFromTagsData(smTags),
            filterKey,
          })
        );
        break;

      default:
        break;
    }
  });

  const customFields = getCustomFieldsData(customFieldResponse);
  const dropdownCustomFields = customFields.filter(
    ({ type }) => type === CUSTOM_FIELDS_TYPES.DROPDOWN
  );

  dropdownCustomFields?.forEach((customFieldData) =>
    filtersData.push(
      getFilterDataObject({
        filterKey: CUSTOM_FIELD_FILTER_KEY,
        customFieldData,
      })
    )
  );

  return filtersData;
};
